import {Typography} from "@mui/material";
import React from "react";
import {H1, Typographies} from "../utils/typography_consts";

export interface AdminTitleProps {
    title: string;
}

const AdminTitle = (props: AdminTitleProps) => {
    return (
        <Typography sx={{mb: 2.5, fontWeight: 700}} component={H1} variant={Typographies.h5}>
            {props.title}
        </Typography>
    );
};

export default AdminTitle;
